type PasswordFieldName = 'current_password' | 'new_password' | 'confirm_new_password';

export type SnackbarProps = {
  isOpen: boolean;
  type: 'success' | 'warning' | 'error' | 'info';
  message: string;
}

export type PasswordsProps = {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  snackbar: SnackbarProps;
  errors: PasswordFieldName[];
}

export type ActionProps = {
  type: 'SET_CURRENT_PASSWORD' | 'SET_NEW_PASSWORD' | 'SET_CONFIRM_NEW_PASSWORD' | 'SET_SNACKBAR' | 'SET_USER_CURRENT_PASSWORD' | 'SET_ERROR';
  payload?: any;
}

const passwordReducer = (state: PasswordsProps, action: ActionProps) => {
  switch (action.type) {
    case 'SET_CURRENT_PASSWORD':
      return { ...state, currentPassword: action.payload, errors: [] } as PasswordsProps;

    case 'SET_NEW_PASSWORD':
      return { ...state, newPassword: action.payload, errors: [] } as PasswordsProps;

    case 'SET_CONFIRM_NEW_PASSWORD':
      return { ...state, confirmNewPassword: action.payload, errors: [] } as PasswordsProps;

    case 'SET_SNACKBAR':
      return { ...state, snackbar: action.payload } as PasswordsProps;

    case 'SET_USER_CURRENT_PASSWORD':
      return { ...state, userCurrentPassword: action.payload } as PasswordsProps;

    case 'SET_ERROR':
      return { ...state, errors: [...state.errors, action.payload] } as PasswordsProps;

    default:
      return state;
  }
};

export default passwordReducer;